module.exports = __webpack_public_path__ + "img/slogan_new.62a3a417.svg";